import React, { useEffect, useState } from "react";
import filter from "../assets/images/filter-icon.svg";
import backArrow from "../assets/images/arrow_icon.png";
import Typewriter from "typewriter-effect";

const ObjectionResponse = ({ data, backhandler }) => {
  const [response, setResponse] = useState("");

  const generateResponse = async () => {
    if (data) {
      const payload = {
        model: "gpt-3.5-turbo",
        messages: [{ role: "user", content: data.prompts }],
      };
      try {
        const response = await fetch(
          "https://api.openai.com/v1/chat/completions",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer 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`,
            },
            body: JSON.stringify(payload),
          }
        );

        if (!response.ok) {
          const errorDetails = await response.text();
          console.error("Error Response:", errorDetails);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonData = await response.json();
        let res = jsonData.choices[0]?.message?.content;

        if (typeof res === "string") {
          res = res.replace(/['"]/g, "");
          const paragraphs = res
            .split("\n")
            .filter((paragraph) => paragraph.trim() !== "");
          setResponse(paragraphs.join("<br/>")); // Join paragraphs with line breaks for the Typewriter
        } else {
          console.error("Response content is not a string:", res);
        }
      } catch (error) {
        console.error("Error calling OpenAI API:", error);
        console.log("Failed to fetch response");
      }
    }
  };

  useEffect(() => {
    if (data) {
      generateResponse();
    }
  }, [data]);

  return (
    <div className="container cl-main-container">
      <div className="card p-3 bg-transparent cl-main-card">
        <div className="card cl-secondary-card">
          <div className="card-body p-4">
            <div className="cl-filter-icon">
              <span>
                <img className="img-fluid" src={filter} alt="Filter" />
              </span>
              <label>Conversion Lab</label>
              <hr className="cl-heading-border" />
            </div>
            <div className="form-floating mt-3">
              <div className="p-4 text-center cl-internal-area-container">
                <div
                  id="cl-floating-textarea"
                  className="d-flex justify-content-center align-items-center"
                >
                  <div className="cl-internal-pra">
                    {response ? (
                      <Typewriter
                        options={{
                          delay: 25, // Lower value for faster typing
                          cursor: "", // This sets an initial cursor character
                        }}
                        onInit={(typewriter) => {
                          typewriter
                            .typeString(response)
                            .callFunction(() => {
                              document.querySelector(
                                ".Typewriter__cursor"
                              ).style.display = "none"; // This hides the cursor
                            })
                            .start();
                        }}
                      />
                    ) : (
                      "Loading..."
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2 d-flex align-items-center justify-content-between">
              <div>
                <button
                  type="button"
                  className="btn cl-goback-btn"
                  onClick={backhandler}
                >
                  <span className="me-1 align-items-center">
                    <img className="img-fluid" src={backArrow} alt="Go Back" />
                  </span>
                  Go Back
                </button>
              </div>
              <div>
                <label className="cl-internal-pra cl-page-info ms-3">
                  {data && data.objection}
                </label>
              </div>
              <div className="w-25"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObjectionResponse;
